import type { NDateLocale } from './enUS'
import { de } from 'date-fns/locale'

const dateDeDE: NDateLocale = {
  name: 'de-DE',
  locale: de
}

export default dateDeDE
